import React from 'react';

const VehicleExport = ({ datasets }) => {
    if (!datasets || datasets.length === 0) return null;

    return (
        <>
            {datasets.map((dataset, rowIndex) => {
                const total = dataset.data.reduce((acc, item) => acc + parseInt(item.count || 0, 10), 0);

                return (
                    <table className="d-none export-all" id={"vehicle-export"}>
                        <thead>
                        <tr>
                            <th>Sentido</th>
                            <th>Total</th>
                            {dataset.export?.map((value, index) => (
                                <th key={`head-${index}`}>{value.data}</th>
                            ))}
                        </tr>
                        </thead>

                        <tbody>
                        <tr key={`row-${rowIndex}`}>
                            <td>{dataset.title}</td>
                            <td>{total}</td>

                            {dataset.export.map((value, colIndex) => (
                                <td key={`col-${colIndex}`}>{value.count}</td>
                            ))}
                        </tr>
                        </tbody>
                    </table>
                );
            })}
        </>
    );
};

export default VehicleExport;